import React, { useEffect } from 'react';
import { FitnessHeroInfo } from './fitness/FitnessHeroInfo';
import { FitnessHeroForm } from './fitness/FitnessHeroForm';
import { FitnessWhyMartialArts } from './fitness/FitnessWhyMartialArts';
import { FitnessConditioning } from './fitness/FitnessConditioning';
import { FitnessAdult } from './fitness/FitnessAdult';
import { FitnessKids } from './fitness/FitnessKids';
import { FitnessFamily } from './fitness/FitnessFamily';
import { FitnessClassTimes } from './fitness/FitnessClassTimes';
import { FitnessReviews } from './fitness/FitnessReviews';
import { FitnessFAQHeader } from './fitness/FitnessFAQHeader';
import { FitnessFAQQuestions } from './fitness/FitnessFAQQuestions';
import { FitnessRelatedLinks } from './fitness/FitnessRelatedLinks';
import { FitnessFinalCTA } from './fitness/FitnessFinalCTA';
import { SITE_IMAGES } from '../components/siteImages';
export function Fitness() {
  useEffect(() => {
    document.title = 'Are Martial Arts Good for Fitness? | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Storm Taekwondo helps kids, adults, and families build strength, flexibility, endurance, and confidence through structured Taekwondo classes in Farmington Hills.');
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-1353">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-1354">
        <div className="absolute inset-0 opacity-20" data-id="element-1355">
          <img src={SITE_IMAGES.adultClasses} alt="Adults training at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-1356" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-1357" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1358">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1359">
            <FitnessHeroInfo data-id="element-1360" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-1361">
              <FitnessHeroForm data-id="element-1362" />
            </div>
          </div>
        </div>
      </section>
      <FitnessWhyMartialArts data-id="element-1363" />
      <FitnessConditioning data-id="element-1364" />
      <FitnessAdult data-id="element-1365" />
      <FitnessKids data-id="element-1366" />
      <FitnessFamily data-id="element-1367" />
      <FitnessClassTimes data-id="element-1368" />
      <FitnessReviews data-id="element-1369" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-1370">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1371">
          <FitnessFAQHeader data-id="element-1372" />
          <FitnessFAQQuestions data-id="element-1373" />
        </div>
      </section>
      <FitnessRelatedLinks data-id="element-1374" />
      <FitnessFinalCTA data-id="element-1375" />
    </div>;
}